import { QueryClient } from "@tanstack/react-query";
import { USER_ACCESS } from "~/shared/api/users/users.constants";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { notFound } from "~/shared/util/notFound";

export async function userAccessGuardLoader(access: (keyof typeof USER_ACCESS)[], queryClient: QueryClient) {
  const user = await queryClient.ensureQueryData({
    ...USERS_QUERIES.profile(),
    retry: false,
  });
  const hasAccess = user?.roles?.some((role: keyof typeof USER_ACCESS) => {
    return access.includes(role);
  });

  if (!hasAccess) {
    notFound();
  }

  return null;
}
